import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import ErrorWrapper from '@components/BaseComponents/ErrorWrapper';
import Uploader from '@components/BaseComponents/Uploader';
import useDebounce from "@hooks/useDebounce";

import Form from 'deltoid/core/Form';
import { Caption } from 'deltoid/core/Blocks/Typography';

const CommentForm = ({
  remark,
  submit,
  btnDisabled,
  btnLoading,
  className,
  uploader,
  onChangeComment,
}) => {
  const [comment, setComment] = useState(null);
  const debouncedComment = useDebounce(comment, 500);

  useEffect(() => {
    if (debouncedComment !== null) {
      onChangeComment && onChangeComment(comment);
    }
  }, [debouncedComment]);
  const { errors, register, handleSubmit } = useForm();
  const {
    onFileDropAccepted,
    onFileDropRejected,
    handleRemoveFile,
    allowedFileExtensions,
    maxFileSizeInMB,
    ...rest
  } = uploader;
  return (
    <div className={`step-comment-container ${className}`} onClick={(e) => { e.stopPropagation() }}>
      <div className='form-container'>
        <div className='support p-2'>
          <img src='../../../assets/images/onboarding/support.svg' width='100%' />
        </div>
        <form onSubmit={handleSubmit(submit ? submit : () => {})} className='w-100 overflow-auto p-2'>
          <Caption className='pb-2'>
            {remark}
          </Caption>
          <Form.Group>
            <Form.Textarea
              ref={register({
                required: 'This field can not be empty'
              })}
              name='comment'
              placeholder='Write your comment'
              onChange={(e) => setComment(e.target.value)}
            />
            <ErrorWrapper errors={errors} fieldName='comment' />
          </Form.Group>
          {
            uploader && <Uploader
              onFileDropAccepted={onFileDropAccepted}
              onFileDropRejected={onFileDropRejected}
              handleRemoveFile={handleRemoveFile}
              allowedFileExtensions={allowedFileExtensions}
              maxFileSizeInMB={maxFileSizeInMB}
              {...rest}
            />
          }
          {
            submit && (
              <Form.Button
                className='float-right'
                onClick={handleSubmit(submit)}
                disabled={btnDisabled}
                loading={btnLoading}
                typ='button'
              >
                Send
              </Form.Button>
          )}
        </form>
      </div>
    </div>
  )
};

CommentForm.defaultProps = {
  remark: '',
  btnDisabled: false,
  btnLoading: false,
  className: '',
  uploader: false,
  submit: false,
}

CommentForm.propTypes = {
  remark: PropTypes.node,
  submit: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  btnDisabled: PropTypes.bool,
  btnLoading: PropTypes.bool,
  className: PropTypes.string,
  uploader: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object,
  ]),
}

export default CommentForm;